import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

// Personalizza questi colori
const BUTTON_BG = "#334155"; // Sfondo bottone
const BUTTON_BORDER = "#475569"; // Bordo bottone
const ICON_COLOR = "#94a3b8"; // Colore icona

export const SidebarCollapseButton: React.FC<{
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
  canCollapse: boolean;
}> = ({ collapsed, onCollapse, canCollapse }) => {
  if (!canCollapse) return null;
  return (
    <Tooltip
      title={collapsed ? "Espandi sidebar" : "Comprimi sidebar"}
      placement="right"
    >
      <IconButton
        onClick={() => onCollapse(!collapsed)}
        sx={{
          position: "absolute",
          top: "50%",
          right: "-16px",
          transform: "translateY(-50%)",
          zIndex: 1302,
          bgcolor: BUTTON_BG,
          border: `1px solid ${BUTTON_BORDER}`,
          boxShadow: 1,
          width: 32,
          height: 32,
          transition: "right 0.2s",
          color: ICON_COLOR,
          ":hover": { bgcolor: BUTTON_BORDER },
          display: { xs: "none", sm: "flex" },
        }}
      >
        {collapsed ? <MenuIcon /> : <MenuOpenIcon />}
      </IconButton>
    </Tooltip>
  );
};
